<template>
  <div class="containerFull_basketballLeagueCBA">
    <BasketballLeagueCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></BasketballLeagueCommon>
  </div>
</template>

<script>
// 足球 联赛 CSL|中超 容器
import BasketballLeagueCommon from '@containers/platfrom_basketball/basketballLeague_common.vue'
import containerFull_data from '@mixins/football/league/containerFull_csl_data'
export default {
  name: 'containerFull_FBLCSL',
  mixins: [containerFull_data],
  components: {
    BasketballLeagueCommon,
  },
}
</script>
